import Select from "react-select";
import UnForm from "../../../../../../Components/Form";
import { ChangeEvent, Dispatch, SetStateAction } from "react";
import { FormProvider } from "react-hook-form";
import { MoneyReaisFieldMask } from "../../../../../../Validations/InputMasks";
import { IFiltroListarContatos } from "../../../../../../Interfaces/Automacao/Audiencia/AudienciaInterfaces";
import { ListarTipoContasController } from "../../../../../../Controllers/Geral/CadastrarCliente/CadastrarClienteController";
import { ListarPerfilFinanceiroController } from "../../../../../../Controllers/Geral/GestaoDeCadastros/PerfilFinanceiro/PerfilFinanceiroController";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { useModalFiltroContatos } from "./useModalFiltroContatos";

interface IModalFiltroContatosProps {
    filter: any;
    filtroGestaoStorage: any;
    setIdEmpreendimento: Dispatch<SetStateAction<number[]>>;
    idEmpreendimento: Array<number>;
    filtroInicial: IFiltroListarContatos;
    updateList: (filter: IFiltroListarContatos, page: number) => void;
}

export default function ModalFiltroContatos(props: IModalFiltroContatosProps) {
    const {
        FormMethods,
        handleFilterContact,
        maskReal,
        setValue,
        errors,
        idEmpreendimentoRef,
        options,
        customStyles,
        listarJornadaEtapa,
        limparFiltros,
        reset,
    } = useModalFiltroContatos(props);

    return (
        <>
            <FormProvider {...FormMethods}>
                <UnForm
                    handleSubmit={handleFilterContact}
                    usingContext
                    className="row"
                >
                    <div className="form-group b-5 col-12">
                        <label>Nome do Contato</label>
                        <UnForm.Input
                            className="form-control"
                            type="text"
                            name="DS_NOME_CONTATO"
                        />
                    </div>
                    <div className="form-group b-5 col-12">
                        <UnForm.LazySelect
                            label={"Tipo de Conta"}
                            className={`form-control placeholder-dark-75`}
                            name="ID_TIPO_CONTA"
                            registerOptions={{
                                valueAsNumber: true,
                            }}
                            {...FormMethods}
                            defaultValue={props.filter.current?.ID_TIPO_CONTA}
                            controller={ListarTipoContasController}
                            getDS={(s) => s.DS_TIPO_CONTA}
                            getKeyValue={(s) => s.ID_TIPO_CONTA}
                        >
                            <option value={0}></option>
                        </UnForm.LazySelect>
                    </div>
                    <div className="form-group b-5 col-6">
                        <UnForm.Input
                            label="Valor de Venda Geral Total Min:"
                            name="VL_VGV_TOTAL_INICIAL"
                            registerOptions={{
                                setValueAs: (v: string) => {
                                    return Number(
                                        MoneyReaisFieldMask.unMask(v)
                                    );
                                },
                            }}
                            onChange={maskReal("VL_VGV_TOTAL_INICIAL")}
                        ></UnForm.Input>
                    </div>
                    <div className="form-group b-5 col-6">
                        <UnForm.Input
                            label="Valor de Venda Geral Total Max:"
                            name="VL_VGV_TOTAL_FINAL"
                            registerOptions={{
                                setValueAs: (v: string) => {
                                    return Number(
                                        MoneyReaisFieldMask.unMask(v)
                                    );
                                },
                            }}
                            onChange={maskReal("VL_VGV_TOTAL_FINAL")}
                        ></UnForm.Input>
                    </div>
                    <div className="form-group b-5 col-6">
                        <UnForm.Input
                            label="Unidade Min:"
                            name="NR_UNIDADES_INICIAL"
                            // registerOptions={{
                            //     required: true,
                            //     // validate: validateMin,
                            // }}
                            onChange={(e: ChangeEvent<HTMLInputElement>) => {
                                setValue(
                                    "NR_UNIDADES_INICIAL",
                                    e.target.value.replace(/[^0-9]/g, "")
                                );
                            }}
                        ></UnForm.Input>
                        {errors.NR_UNIDADES_INICIAL && (
                            <p>{errors.NR_UNIDADES_INICIAL.message}</p>
                        )}
                    </div>
                    <div className="form-group b-5 col-6">
                        <UnForm.Input
                            label="Unidade Max:"
                            name="NR_UNIDADES_FINAL"
                            // registerOptions={{
                            //     required: true,
                            //     validate: validateMax,
                            // }}
                            onChange={(e: ChangeEvent<HTMLInputElement>) => {
                                setValue(
                                    "NR_UNIDADES_FINAL",
                                    e.target.value.replace(/[^0-9]/g, "")
                                );
                            }}
                        ></UnForm.Input>
                        {errors.NR_UNIDADES_FINAL && (
                            <p>{errors.NR_UNIDADES_FINAL.message}</p>
                        )}
                    </div>
                    <div className="form-group b-5 col-12">
                        <label>Empreendimento</label>
                        <Select
                            name="ID_EMPREENDIMENTO"
                            ref={idEmpreendimentoRef}
                            options={options}
                            isClearable
                            isMulti
                            onChange={(e) => {
                                props.setIdEmpreendimento(
                                    e.map((value) => value?.value)
                                );
                            }}
                            components={{
                                DropdownIndicator: () => null,
                                IndicatorSeparator: () => null,
                            }}
                            styles={customStyles}
                            placeholder={""}
                            noOptionsMessage={() => "Sem opções"}
                        />
                    </div>
                    <div className="form-group b-5 col-12">
                        <UnForm.LazySelect
                            label={"Perfil Financeiro"}
                            className={`form-control placeholder-dark-75`}
                            name="ID_PERFIL_FINANCEIRO_CONTA"
                            registerOptions={{
                                valueAsNumber: true,
                            }}
                            {...FormMethods}
                            defaultValue={
                                props.filter.current?.ID_PERFIL_FINANCEIRO_CONTA
                            }
                            controller={ListarPerfilFinanceiroController}
                            getDS={(s) => s.DS_PERFIL_FINANCEIRO_CONTA}
                            getKeyValue={(s) => s.ID_PERFIL_FINANCEIRO_CONTA}
                        >
                            <option value={0}></option>
                        </UnForm.LazySelect>
                    </div>
                    <div className="form-group b-5 col-12">
                        <UnForm.LazySelect
                            label={"Etapa da Jornada"}
                            className={`form-control placeholder-dark-75`}
                            name="ID_ETAPA_JORNADA"
                            registerOptions={{
                                valueAsNumber: true,
                            }}
                            {...FormMethods}
                            defaultValue={
                                props.filter.current?.ID_ETAPA_JORNADA
                            }
                            controller={listarJornadaEtapa}
                            getDS={(s) => s.DS_ETAPA_JORNADA}
                            getKeyValue={(s) => s.ID_ETAPA_JORNADA}
                        >
                            <option value={0}></option>
                        </UnForm.LazySelect>
                    </div>
                    <div className="col-12 d-flex align-items-end justify-content-start mt-3">
                        <button
                            type="submit"
                            id="kt_login_signin_submit"
                            className="btn btn-block btn-outline-primary mt-2"
                        >
                            Filtrar
                        </button>
                    </div>
                    <div className="col-12 d-flex align-items-end justify-content-start">
                        <button
                            type="button"
                            onClick={() => {
                                props?.filtroGestaoStorage?.remove();
                                props.filter.current = props.filtroInicial;
                                reset(props.filtroInicial);
                                limparFiltros();
                            }}
                            id="kt_login_signin_submit"
                            className="btn btn-block btn-outline-danger mt-2"
                        >
                            <FontAwesomeIcon icon={faTimes} className="mr-2" />
                            Limpar Filtro
                        </button>
                    </div>
                </UnForm>
            </FormProvider>
        </>
    );
}
